import { WidgetType } from "../Enums/WidgetType";
import { MultipleFilterModel } from "../Models/MultipleFilterModel";
import { FiltersManager } from "./FiltersManager";

export class MatchListManager {

    constructor(private containerElement: JQuery) {
    }

    public filtersManager : FiltersManager;

    public initialize() {

        let self = this;

        this.filtersManager = new FiltersManager(this.containerElement.find('.filter-container'), WidgetType.MatchWidget);
        this.filtersManager.initialize();

        this.filtersManager.onFiltersChange.subscribe((sender, result) => {
            self.loadMatches(result.searchString, result.simpleFilters, result.multipleFilters);
        })
        
        let searchString = $(this.containerElement).data('search') as string;
        self.loadMatches(searchString, undefined, undefined);
    }

    loadUpdates(search: string, simpleFilters : string[] | undefined, multipleFilters : MultipleFilterModel[] | undefined) {

        let self = this;

        var updateListItems = this.containerElement.find('[data-update-list-id]');
        updateListItems.each((index, element) => {  
            var updateListElement = $(element);

            let pageNumber = 1;

            let updateId = updateListElement.data('update-id');
            if (updateId == undefined) {
                updateId = '';
            }

            let active = updateListElement.data('active');
            if (active == undefined) {
                active = '';
            }
                    
            let maxNumber = updateListElement.data('max-number');
            if (maxNumber == undefined) {
                maxNumber = '';
            }
            
            let showMoreText= updateListElement.data('show-more-text');
            if (showMoreText == undefined) {
                showMoreText = '';
            }

            let hideLinkText = updateListElement.data('hide-link-text');
            if (hideLinkText == undefined) {
                hideLinkText = '';
            }

            let contentAlign= updateListElement.data('content-align');
            if (contentAlign == undefined) {
                contentAlign = '';
            }

            let blockId = updateListElement.data('block-id');
            if (blockId == undefined) {
                blockId = '';
            }

            if (search == undefined) {
                search = '';
            }

            updateListElement.html('<div class="btn-spinner"></div>');

            $.post(`/update/updateslist`,
            {
                'pageNumber' : pageNumber,
                'updateId' : updateId,
                'maxNumber' : maxNumber,
                'active' : active,
                'search' : search,
                'showMoreText' : showMoreText,
                'hideLinkText' : hideLinkText,
                'contentAlign' : contentAlign,
                'blockId' : blockId,
                'simpleFilters' : simpleFilters,
                'multipleFilters' : multipleFilters,
                "__RequestVerificationToken": (window as any).getToken()
            },
            function(data){
                updateListElement.html(data.view);

                self.filtersManager.setFiltersCount(+data.totalNumberOfItems, data.labelFilters);

                let showMoreBtn = updateListElement.find('#btn-show-more');

                if (<boolean>(data.hasMorePages) == false) {
                    
                    showMoreBtn.hide();
                }
                else {
                    showMoreBtn.click((e) => {
                        showMoreBtn.find('.btn-spinner').removeClass('d-none');
                        e.preventDefault();

                        pageNumber += 1;

                        $.post(`/update/updateslist`,
                        {
                            'pageNumber' : pageNumber,
                            'updateId' : updateId,
                            'maxNumber' : maxNumber,
                            'active' : active,
                            'search' : search,
                            'showMoreText' : showMoreText,
                            'hideLinkText' : hideLinkText,
                            'blockId' : blockId,
                            'simpleFilters' : simpleFilters,
                            'multipleFilters' : multipleFilters,
                            "__RequestVerificationToken": (window as any).getToken()
                        },
                        function(data){
                            showMoreBtn.find('.btn-spinner').addClass('d-none');

                            $(data.view).insertAfter(updateListElement.find('.row').last());

                            if (<boolean>(data.hasMorePages) == false) {
                                showMoreBtn.hide();
                            }
                            else {
                                var showMoreText = <string>(data.showMoreText);
                                if(showMoreText.length >= 1) {
                                    showMoreBtn.find('#btn-show-more-text').text(showMoreText);
                                }
                            }
                        });
                    });
                }
            });
        })  
    }

    loadMatches(search: string, simpleFilters : string[] | undefined, multipleFilters : MultipleFilterModel[] | undefined) {

        let self = this;

        var matchListItems = this.containerElement.find('[data-match-list-id]');
        matchListItems.each((index, element) => {  
            var matchListElement = $(element);

            matchListElement.html('<div class="btn-spinner"></div>')

            let pageNumber = 1;

            let blockId = matchListElement.data('block-id');
            if (blockId == undefined) {
                blockId = '';
            }

            if (search == undefined) {
                search = '';
            }

            $.post(`/match/matcheslist`, 
            {
                "PageNumber": pageNumber,
                "Search": search,
                "BlockId": blockId,
                'SimpleFilters' : simpleFilters,
                'MultipleFilters' : multipleFilters,
                "__RequestVerificationToken": (window as any).getToken()
            },
            function(data){   
                matchListElement.html(data.view);

                self.filtersManager.setFiltersCount(+data.totalNumberOfItems, data.labelFilters);

                let showMoreBtn = matchListElement.find('#btn-show-more');

                if (Boolean(data.hasMorePages) == false) {
                    showMoreBtn.hide();
                }
                else {
                    showMoreBtn.click((e) => {
                        showMoreBtn.find('.btn-spinner').removeClass('d-none');

                        e.preventDefault();

                        pageNumber += 1;

                        var usedMatchIds = [];
                        matchListElement.find('a[data-match-id]').each((index, element) => {
                            usedMatchIds.push($(element).data('match-id').toString());
                        });

                        $.post(`/match/matcheslist`, 
                        {
                            "PageNumber": pageNumber,
                            "Search": search,
                            "BlockId": blockId,
                            "UsedMatchIds": usedMatchIds,
                            'SimpleFilters' : simpleFilters,
                            'MultipleFilters' : multipleFilters,
                            "__RequestVerificationToken": (window as any).getToken()
                        }, function(data){
                            showMoreBtn.find('.btn-spinner').addClass('d-none');

                            matchListElement.children().first().append(data.view);

                            if (<boolean>(data.hasMorePages) == false) {
                                showMoreBtn.hide();
                            }
                            else {
                                var showMoreText = <string>(data.showMoreText);
                                if(showMoreText.length >= 1) {
                                    showMoreBtn.find('#btn-show-more-text').text(showMoreText);
                                }
                            }
                        });
                    });
                }
            });
        });
    }
}